export const Extraordinary = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
      <path d="M2.84852 4.99959L3.61832 3.66625H0.666992V2.33292H4.38812L5.25635 0.829102L6.41105 1.49577L5.92772 2.33292H7.33366V3.66625H5.15792L4.38812 4.99959H7.33366V6.33292H3.61832L2.74438 7.84662L1.58968 7.17995L2.07872 6.33292H0.666992V4.99959H2.84852Z" fill="#E6F7FF"/>
    </svg>
  )
}
